module.exports = __webpack_public_path__ + "img/Group 4084.251fd15f.png";